module.exports = __webpack_public_path__ + "static/pak-gif-2-747f3c5a60c8a3ef1e9b4e61e99d6447.gif";